export const mockTableData = [
  {
    table_name: 'users',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'username', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'email', data_type: 'VARCHAR(100)', is_nullable: false },
      { column_name: 'password_hash', data_type: 'VARCHAR(255)', is_nullable: false },
      { column_name: 'first_name', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'last_name', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'phone', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'address', data_type: 'TEXT', is_nullable: true },
      { column_name: 'city', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'state', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'zip_code', data_type: 'VARCHAR(10)', is_nullable: true },
      { column_name: 'country', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'updated_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'last_login', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'is_active', data_type: 'BOOLEAN', is_nullable: false, default_value: true },
      { column_name: 'role', data_type: 'VARCHAR(20)', is_nullable: false, default_value: 'user' }
    ]
  },
  {
    table_name: 'orders',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'user_id', data_type: 'INTEGER', is_nullable: false, is_foreign_key: true },
      { column_name: 'order_number', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'total_amount', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'status', data_type: 'VARCHAR(20)', is_nullable: false, default_value: 'pending' },
      { column_name: 'shipping_address', data_type: 'TEXT', is_nullable: true },
      { column_name: 'billing_address', data_type: 'TEXT', is_nullable: true },
      { column_name: 'payment_method', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'shipping_method', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'discount_code', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'tax_amount', data_type: 'DECIMAL(10,2)', is_nullable: false, default_value: 0 },
      { column_name: 'shipping_cost', data_type: 'DECIMAL(10,2)', is_nullable: false, default_value: 0 },
      { column_name: 'order_notes', data_type: 'TEXT', is_nullable: true },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'updated_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'fulfilled_at', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'cancelled_at', data_type: 'TIMESTAMP', is_nullable: true }
    ]
  },
  {
    table_name: 'products',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'name', data_type: 'VARCHAR(100)', is_nullable: false },
      { column_name: 'sku', data_type: 'VARCHAR(50)', is_nullable: false, is_unique: true },
      { column_name: 'description', data_type: 'TEXT', is_nullable: true },
      { column_name: 'price', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'cost', data_type: 'DECIMAL(10,2)', is_nullable: true },
      { column_name: 'category_id', data_type: 'INTEGER', is_nullable: true, is_foreign_key: true },
      { column_name: 'brand', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'weight', data_type: 'DECIMAL(8,2)', is_nullable: true },
      { column_name: 'dimensions', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'color', data_type: 'VARCHAR(30)', is_nullable: true },
      { column_name: 'size', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'stock_quantity', data_type: 'INTEGER', is_nullable: false, default_value: 0 },
      { column_name: 'is_active', data_type: 'BOOLEAN', is_nullable: false, default_value: true },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'updated_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'image_url', data_type: 'VARCHAR(255)', is_nullable: true },
      { column_name: 'rating', data_type: 'DECIMAL(3,2)', is_nullable: true },
      { column_name: 'review_count', data_type: 'INTEGER', is_nullable: false, default_value: 0 }
    ]
  },
  {
    table_name: 'order_items',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'order_id', data_type: 'INTEGER', is_nullable: false, is_foreign_key: true },
      { column_name: 'product_id', data_type: 'INTEGER', is_nullable: false, is_foreign_key: true },
      { column_name: 'quantity', data_type: 'INTEGER', is_nullable: false },
      { column_name: 'unit_price', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'total_price', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false }
    ]
  },
  {
    table_name: 'payments',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'order_id', data_type: 'INTEGER', is_nullable: false, is_foreign_key: true },
      { column_name: 'amount', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'payment_method', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'status', data_type: 'VARCHAR(20)', is_nullable: false },
      { column_name: 'transaction_id', data_type: 'VARCHAR(100)', is_nullable: true },
      { column_name: 'currency', data_type: 'VARCHAR(3)', is_nullable: false, default_value: 'USD' },
      { column_name: 'payment_date', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'confirmation_code', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'payer_name', data_type: 'VARCHAR(100)', is_nullable: true },
      { column_name: 'payer_email', data_type: 'VARCHAR(100)', is_nullable: true },
      { column_name: 'card_last4', data_type: 'VARCHAR(4)', is_nullable: true },
      { column_name: 'card_type', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'refund_status', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'refunded_at', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'updated_at', data_type: 'TIMESTAMP', is_nullable: false }
    ]
  },
  {
    table_name: 'shipments',
    columns: [
      { column_name: 'id', data_type: 'INTEGER', is_primary_key: true },
      { column_name: 'order_id', data_type: 'INTEGER', is_nullable: false, is_foreign_key: true },
      { column_name: 'carrier', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'tracking_number', data_type: 'VARCHAR(100)', is_nullable: true },
      { column_name: 'status', data_type: 'VARCHAR(20)', is_nullable: false },
      { column_name: 'shipped_at', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'estimated_arrival', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'actual_arrival', data_type: 'TIMESTAMP', is_nullable: true },
      { column_name: 'shipping_cost', data_type: 'DECIMAL(10,2)', is_nullable: false },
      { column_name: 'weight', data_type: 'DECIMAL(8,2)', is_nullable: true },
      { column_name: 'dimensions', data_type: 'VARCHAR(50)', is_nullable: true },
      { column_name: 'recipient_name', data_type: 'VARCHAR(100)', is_nullable: false },
      { column_name: 'recipient_phone', data_type: 'VARCHAR(20)', is_nullable: true },
      { column_name: 'delivery_address', data_type: 'TEXT', is_nullable: false },
      { column_name: 'delivery_city', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'delivery_state', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'delivery_zip', data_type: 'VARCHAR(10)', is_nullable: false },
      { column_name: 'delivery_country', data_type: 'VARCHAR(50)', is_nullable: false },
      { column_name: 'delivery_notes', data_type: 'TEXT', is_nullable: true },
      { column_name: 'signature_required', data_type: 'BOOLEAN', is_nullable: false, default_value: false },
      { column_name: 'created_at', data_type: 'TIMESTAMP', is_nullable: false },
      { column_name: 'updated_at', data_type: 'TIMESTAMP', is_nullable: false }
    ]
  }
]; 